// Generated from src/assets/BorderedClose.svg
import React, { PureComponent } from "react";

interface ISVGInfoIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGInfoIcon extends PureComponent<ISVGInfoIconProps, {}> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 25}
        fill={fill || "currentColor"}
        style={style}
        width="25px"
        height="25px"
        viewBox="0 0 25 25"
        enableBackground="new 0 0 25 25"
      >
        <g id="surface1">
          <path
            stroke="none"
            fillRule="nonzero"
            fill="rgb(100%,100%,100%)"
            fillOpacity="1"
            d="M 12.5 1.070312 C 18.800781 1.070312 23.929688 6.199219 23.929688 12.5 C 23.929688 18.800781 18.800781 23.929688 12.5 23.929688 C 6.199219 23.929688 1.070312 18.800781 1.070312 12.5 C 1.070312 6.199219 6.199219 1.070312 12.5 1.070312 M 12.5 0 C 5.597656 0 0 5.597656 0 12.5 C 0 19.402344 5.597656 25 12.5 25 C 19.402344 25 25 19.402344 25 12.5 C 25 5.597656 19.402344 0 12.5 0 Z M 12.5 0 "
          />
          <path
            stroke="none"
            fillRule="nonzero"
            fill="rgb(100%,100%,100%)"
            fillOpacity="1"
            d="M 15.238281 6.546875 C 15.238281 7.433594 14.519531 8.15625 13.628906 8.15625 C 12.742188 8.15625 12.023438 7.433594 12.023438 6.546875 C 12.023438 5.660156 12.742188 4.941406 13.628906 4.941406 C 14.519531 4.941406 15.238281 5.660156 15.238281 6.546875 Z M 15.238281 6.546875 "
          />
          <path
            stroke="none"
            fillRule="nonzero"
            fill="rgb(100%,100%,100%)"
            fillOpacity="1"
            d="M 10.054688 10.535156 L 10.023438 11.070312 C 10.023438 11.070312 10.832031 11.042969 10.980469 11.28125 C 11.132812 11.519531 11.21875 11.277344 10.894531 12.410156 C 10.566406 13.542969 9.078125 18.332031 9.078125 18.332031 C 9.078125 18.332031 8.929688 19.167969 9.078125 19.523438 C 9.226562 19.882812 9.582031 20.308594 10.832031 20.355469 C 12.351562 20.417969 13.808594 18.242188 14.105469 17.410156 C 14.105469 17.410156 13.902344 17.195312 13.636719 17.378906 C 13.460938 17.496094 13.269531 17.847656 13.011719 18.148438 C 12.59375 18.636719 12.042969 18.90625 11.886719 18.761719 C 11.75 18.636719 14.777344 10.078125 14.496094 10.011719 C 14.386719 9.984375 10.054688 10.535156 10.054688 10.535156 Z M 10.054688 10.535156 "
          />
        </g>
      </svg>
    );
  }
}
